import React from "react";

export default function AprilFoolDay1({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-apr12{fill:#fbd713}.cls-apr15{fill:#e8bb00}"}</style>
        </defs>
        <path
          d="M1533.56 1887.25H759.75c-65.4 0-118.61-53.21-118.61-118.61V994.83c0-65.4 53.21-118.61 118.61-118.61h773.81c65.4 0 118.61 53.21 118.61 118.61v773.81c0 65.4-53.21 118.61-118.61 118.61ZM759.75 920.21c-41.14 0-74.61 33.47-74.61 74.61v773.81c0 41.14 33.47 74.61 74.61 74.61h773.81c41.14 0 74.61-33.47 74.61-74.61V994.82c0-41.14-33.47-74.61-74.61-74.61H759.75Z"
          style={{
            fill: "#9f15f9",
          }}
        />
        <path
          d="M780.59 162.67c10.22 8.42-97.11 102.26-86.29 226.8 7.68 88.44 71.69 154.96 121.21 195.68-46.98 80.51-93.96 161.02-140.94 241.52-14.05-11.53-165.4-139.96-148.1-336.31 19.64-222.93 239.52-339.74 254.13-327.7Z"
          style={{
            fill: "#ff2b80",
          }}
        />
        <path
          d="M694.3 389.47c7.67 88.44 71.69 154.96 121.2 195.68-46.97 80.5-93.95 161.02-140.94 241.53-15.28-9.28-31.68-21.21-47.76-36.62-60.95-58.41-79.55-130.62-86-167.06 22.1-1.96 48.16-2.53 77.17.2 17.01 1.6 32.68 4.12 46.83 7.07 14.02-17.83 29.25-36.12 45.76-54.66 9.43-10.59 18.81-20.73 28.11-30.45-12.69-12.38-29.95-31.86-44.47-59.21-35.53-66.92-28.52-131.65-25.38-152.23 12.65-83.02 73.86-140.02 110.26-171.7.63.14 1.14.36 1.51.67 10.22 8.42-97.12 102.25-86.29 226.8Z"
          style={{
            fill: "#e51a77",
          }}
        />
        <path
          d="M171.51 975.75c9.95 8.73 85.38-112.25 210.03-121.53 88.52-6.59 164.45 45.93 212.58 88.28 106.68-45.74 213.36-91.49 320.04-137.23C788.49 675.28 610 622.9 454.24 672.39c-210.08 66.75-295.33 292.3-282.73 303.37Z"
          style={{
            fill: "#84e000",
          }}
        />
        <path
          d="M914.15 805.26 594.11 942.49c-48.12-42.35-124.05-94.87-212.58-88.28-124.65 9.28-200.08 130.27-210.04 121.54-2.75-2.41-.84-15.03 6.01-33.98 23.25-18.22 94.42-110.8 202.85-118.88 88.53-6.59 164.45 45.93 212.59 88.28l298.51-128c7.74 7.09 15.3 14.46 22.68 22.1Z"
          style={{
            fill: "#7ec600",
          }}
        />
        <path
          d="M1248.07 514.12c-.53 13.23-140.17-15.53-232.83 68.37-65.8 59.58-80.1 150.79-82.6 214.85-106.68 45.74-213.36 91.49-320.04 137.23-7.53-180.65 77.57-346.06 220.8-424.78 193.18-106.17 415.34-12.43 414.67 4.32Z"
          style={{
            fill: "#01befe",
          }}
        />
        <path
          d="M1248.07 514.12c-.53 13.23-140.17-15.53-232.83 68.36-65.8 59.59-80.1 150.79-82.6 214.85L612.61 934.56a522.07 522.07 0 0 1-.37-31.37l290.74-124.67c2.49-64.06 16.79-155.27 82.59-214.85 92.66-83.91 232.3-55.14 232.83-68.38 0-.22-.02-.46-.1-.7 19.07 8.28 29.92 15.8 29.77 19.52Z"
          style={{
            fill: "#00addb",
          }}
        />
        <path
          d="m587.642 938.264 345.689-148.233 25.305 59.013c5.498 12.82-.45 27.699-13.271 33.197l-299.22 128.308c-12.822 5.497-27.7-.45-33.198-13.271l-25.305-59.014Z"
          className="cls-apr12"
        />
        <path
          d="m933.32 790.03 24.8 57.83c4.08 9.52 2.18 20.1-4.04 27.53.35-4.19-.29-8.52-2.06-12.66l-24.8-57.82-324.58 139.18 24.8 57.82c1.77 4.13 4.48 7.59 7.76 10.23-9.68-.61-18.67-6.53-22.76-16.05l-24.8-57.83 345.68-148.23Z"
          className="cls-apr15"
        />
        <circle cx={785.23} cy={159.37} r={60.65} className="cls-apr12" />
        <path
          d="M781.11 98.86c20.7-1.39 41.58 7.89 54.16 26.25 18.92 27.63 11.86 65.38-15.77 84.3-23.52 16.11-54.37 13.39-74.7-4.81 17.32 7.9 38.23 6.79 55.08-4.75 25.59-17.53 32.13-52.49 14.6-78.08-8.22-12-20.26-19.8-33.38-22.91Z"
          className="cls-apr15"
        />
        <circle cx={1258.44} cy={512.56} r={60.65} className="cls-apr12" />
        <path
          d="M1301.63 469.96c14.56 14.79 21.15 36.67 15.43 58.17-8.6 32.36-41.82 51.64-74.18 43.04-27.55-7.32-45.62-32.48-45.08-59.75 5.31 18.28 19.79 33.4 39.53 38.65 29.98 7.96 60.74-9.89 68.71-39.87 3.73-14.06 1.79-28.28-4.4-40.24Z"
          className="cls-apr15"
        />
        <circle cx={156.86} cy={984.91} r={60.65} className="cls-apr12" />
        <path
          d="M172.72 926.37c20.03 5.44 36.73 21.03 42.63 42.48 8.87 32.29-10.12 65.67-42.41 74.55-27.49 7.55-55.77-5.08-69.04-28.91 13.8 13.12 33.92 18.89 53.62 13.48 29.91-8.22 47.5-39.14 39.28-69.04-3.85-14.03-12.69-25.33-24.07-32.55Z"
          className="cls-apr15"
        />
        {children}
      </g>
    </svg>
  );
}
